import { Typography, Chip } from "@mui/material";
import { CommissionPayoutActionsPopover } from "./payout-actions-popover";

export const getCommissionPayoutColumns = (onEditClick) => [
  {
    accessorKey: "id",
    header: () => <div>ID</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">{row.original.id}</Typography>
    ),
  },
  {
    accessorKey: "commission",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Commission</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500}>
        {row.original.commission?.name ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "category",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Category</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.category?.name ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "percentage",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Percentage (%)</div>,
    cell: ({ row }) => (
      <Chip
        label={`${row.original.percentage ?? 0}%`}
        size="small"
        color="primary"
        variant="outlined"
      />
    ),
  },
  {
    accessorKey: "createdBy",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Created By</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.createdBy ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "updatedAt",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Last Updated</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.updatedAt
          ? new Date(row.original.updatedAt).toLocaleDateString()
          : "—"}
      </Typography>
    ),
  },
  {
    id: "actions",
    header: () => <div>Actions</div>,
    cell: ({ row }) => (
      <CommissionPayoutActionsPopover
        payout={row.original}
        onEditClick={onEditClick}
      />
    ),
  },
];
